document.addEventListener("DOMContentLoaded", async () => {
    const { initFixedAnchorLink } = await import("../components/anchorlink.js");
    initFixedAnchorLink();
});
